import { render, staticRenderFns } from "./LegendBlock.vue?vue&type=template&id=66c8087f&scoped=true&"
import script from "./LegendBlock.vue?vue&type=script&lang=js&"
export * from "./LegendBlock.vue?vue&type=script&lang=js&"
import style0 from "./LegendBlock.vue?vue&type=style&index=0&id=66c8087f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c8087f",
  null
  
)

export default component.exports